import React from 'react';
import ListItem from '@mui/material/ListItem';
import {ListItemText} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import NotificationItem from './NotificationItem';
import ErrorBoundary from '../../../common/ErrorBoundary';
import useScreenWidth from '../../../common/useScreenWidth';

const useStyles = makeStyles((theme) => ({
  listItemRoot: {
    color: theme.palette.primary.main,
  },
  listItemTextPrimary: {
    color: theme.palette.primary.main,
    fontSize: '18px',
    fontFamily: 'TiemposTextRegular',
    paddingBottom: '3px',
  },
  listItemTextSecondary: {
    fontSize: '12px',
    fontFamily: 'AeonikProReqular',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.5)',
  },
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    cursor: 'pointer',
  },
  box: {
    borderBottom: `2px solid ${theme.palette.gray.border}`,
    '&:hover': {
      background: theme.palette.gray.main,
    },
  },
  red: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    backgroundColor: 'red',
    color: 'red',
    marginRight: '10px',
  },
  invisible: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    backgroundColor: 'rgba(0, 0, 0, 0)',
    color: 'rgba(0, 0, 0, 0)',
    marginRight: '10px',
  },
}));

function Notifications(props: $TSFixMe) {
  const classes = useStyles();
  const width = useScreenWidth();

  return (
    <div
      style={{overflowY: 'scroll', maxHeight: width < 600 ? '100vh' : '45vh'}}>
      {props.notifications && props.notifications.length > 0 ? (
        props.notifications.map((notification: $TSFixMe) => (
          <ErrorBoundary
            key={`NotificationItem_${notification.id}`}
            fallbackUi={null}>
            <NotificationItem
              {...props}
              notification={notification}
              getNotification={props.getNotifications}
            />
          </ErrorBoundary>
        ))
      ) : (
        <ListItem
          style={{padding: '20px', textAlign: 'center'}}
          key={'notifications_clear'}>
          <ListItemText
            classes={{
              primary: classes.listItemTextPrimary,
            }}
            primary="You're all caught up!"
          />
        </ListItem>
      )}
    </div>
  );
}

export default Notifications;
